<template>
  <v-select
    v-model="selected"
    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
    multiple
    label="email"
    class="flex-grow-1 email-to-selector"
    input-id="notification-to"
    placeholder="Ingrese el correo de un alumno"
    :options="alumnos"
    :selectable="() => selected.length < 1"
    :reduce="val => val.matricula"
    @search="onSearch"
    @input="(val) => $emit('add-id-referencia-lk', val[0])"
  >
    <!-- Options -->
    <template #option="{ nombre, email, emailAlt, matricula }">
      <div class="d-flex align-items-center text-truncate">
        <b-avatar
          class="mr-1"
          variant="secondary"
        >
          <feather-icon
            icon="UserIcon"
            size="15"
          />
        </b-avatar>
        <div>
          <div class="font-weight-bolder">
            {{ nombre }} ({{ matricula }})
          </div>
          <div class="font-small-2">
            {{ email }} - {{ emailAlt }}
          </div>
        </div>
      </div>
    </template>

    <!-- Selected option -->
    <template #selected-option="{ nombre, matricula }">
      <span class="text-white">{{ nombre }} ({{ matricula }})</span>
    </template>

    <!-- No options -->
    <template #no-options>
      No encontramos resultados
    </template>

    <!-- Loader -->
    <template #spinner="{ loading }">
      <b-spinner
        v-if="loading"
        small
        variant="primary"
      />
    </template>
  </v-select>
</template>

<script>
import {
  VBTooltip,
  BSpinner,
  BAvatar,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import store from '@/store'
import { avatarText } from '@core/utils/filter'
import { getData } from '@core/utils/http/general'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    vSelect,
    BSpinner,
    BAvatar,
  },
  setup() {
    const toast = useToast()
    const showLoader = ref(false)
    const selected = ref([])
    const alumnos = ref([])

    // * Buscador
    const onSearch = (search, loading) => {
      if (search.length <= 3) return false // SEARCH IT'S EMPTY OR LESS THAN 4 LETTERS
      const paramsRequest = {
        action: 10,
        x: search,
        token: store.state.cuenta.session.token,
      }

      loading(true)
      getData(paramsRequest, 'wsalumno')
        .then(response => {
          loading(false)
          if (response.status === 200) {
            alumnos.value = response.data.data || []
            return true
          }
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error cargando alumnos',
              text: response.data.message,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
          return false
        })
        .catch(error => {
          loading(false)
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error cargando alumnos',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
      return true
    }

    // * Asign default data
    const resetComponent = () => { selected.value = [] }

    return {
      showLoader,
      onSearch,
      selected,
      alumnos,
      avatarText,
      resetComponent,
    }
  },
}
</script>
